export const API_BASE_URL = 'https://test-api-wildlifenl.uu.nl';
